import { NEW_USER_FLOW } from 'services/StudioEvents';

/* @ngInject */
export default class NewUserFlowController {

    constructor(AuthService, $rootScope) {
        this.AuthService = AuthService;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        const authData = this.AuthService.getAuthData();
        if (authData) {
            this.userProfile = authData.profile;
        }

        this.$rootScope.$broadcast(NEW_USER_FLOW);

        if (this.userProfile?.given_name?.length > 1) {
            this.headerText = `Hi ${this.userProfile.given_name} – Welcome to Studio`;
        } else {
            this.headerText = 'Welcome to Studio';
        }
        this.descriptionText = "Almost there — let's get you set up";
    }

    signOut() {
        this.AuthService.signOut();
    }
}
